var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.25 8A2.75 2.75 0 0 1 6 5.25h12A2.75 2.75 0 0 1 20.75 8v8A2.75 2.75 0 0 1 18 18.75H6A2.75 2.75 0 0 1 3.25 16zM6 6.75c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V8c0-.69-.56-1.25-1.25-1.25zm-.108 1.17 5.395 3.744a1.25 1.25 0 0 0 1.426 0l5.395-3.745.855 1.233-3.435 2.384 3.435 2.383-.855 1.233-3.895-2.704-.645.448a2.75 2.75 0 0 1-3.136 0l-.645-.448-3.895 2.704-.855-1.233 3.435-2.383-3.435-2.384z",
    clipRule: "evenodd"
  })));
};
export default SvgEmail;